export const login = {
  "title": "ลงชื่อเข้าใช้แผงผู้ดูแลระบบ",
  "emailLabel": "ที่อยู่อีเมล",
  "passwordLabel": "รหัสผ่าน",
  "signingInButton": "กำลังลงชื่อเข้าใช้...",
  "signInButton": "ลงชื่อเข้าใช้",
  "pinLoginLink": "สลับไปที่การเข้าสู่ระบบด้วย PIN",
  "registerLink": "สมัครสมาชิกใหม่"
};
